var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('section',{staticClass:"section-light section-centered"},[_c('h2',[_vm._v(_vm._s(_vm.$t("sensorSelect.title")))]),_c('Form',{on:{"onSubmit":_vm.handleSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }